var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.bem()},[_c('div',{staticClass:"int",style:(_vm.style)},[_vm._v(_vm._s(_vm.priceInt))]),(_vm.isShoeDot)?_c('div',{staticClass:"dot",style:(_vm.style)},[_vm._v(_vm._s(_vm.priceDot))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }